import Api from 'utils/api'
import i18n from 'utils/i18n'
import {produce} from 'immer'
import {AppRoutes} from "utils/routes";
import {
  TypeReadBus, SelfCheckinStepEnum, SelfBoardingStepEnum
} from "components/shared/enums/global-enums.tsx";

import {parseBCBPBarcode, airportsDic} from 'utils/helperFunctions.js'

const { ServiceBusClient } = require("@azure/service-bus");

export const selfBoardingSlice = ((set, get) => ({

  selfCheckinChoices: [],
  scannedElms: {},
  pendingPassScan: {},

  selfCheckinChoicesObj: {
    fr_id: null,
    first_name: null,
    last_name: null,
    bags: [],
    printBoardingPass: false,
    printBaggageTags: false,
    typeFor: SelfCheckinStepEnum.PASSENGER, 
    confirmed: false 
  },

  messageReceiverBoarding: null,

  actions: {

    openGate: async (redirectFunc, overwrite=false, navigate) => {
      get().actions.startLoading();
      const api = new Api();
      let data = {location_id: get().actions.retrieveItem("touchpoint")};
      data.overwrite = overwrite;
      api.openGate(data)
        .then((response) => {
          get().actions.readBusInfoForBoarding(response.data, redirectFunc, TypeReadBus.SCAN_BOARDING_PASS, !overwrite, navigate);

          get().actions.stopLoading();
        })
      .catch((err) => {
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t(err.response.data[0]?.message)})
        navigate(AppRoutes.demoChoicesPath);


        
        get().actions.stopLoading();
      });
    },

    closeGate: async () => {
      get().actions.stopReadingBusInfosBoarding();

      const api = new Api();
      let data = {location_id: get().actions.retrieveItem("touchpoint")};
      api.closeGate(data)
        .then((response) => {
        })
      .catch((err) => {
      });
    },

    acceptPassenger: async () => {
      const api = new Api();
      let data = {location_id: get().actions.retrieveItem("touchpoint")};
      api.acceptPassenger(data)
        .then((response) => {
        })
      .catch((err) => {
      });
    },

    rejectPassenger: async () => {
      const api = new Api();
      let data = {location_id: get().actions.retrieveItem("touchpoint")};
      api.rejectPassenger(data)
        .then((response) => {
        })
      .catch((err) => {
      });
    },


    stopReadingBusInfosBoarding: async () => {
      try{
        await get().messageReceiverBoarding.close();
        set(produce((state) => { 
            state.messageReceiverBoarding = null;
        }));
      }catch(Exeption){
      }
    },
  

    readBusInfoForBoarding: async (data, redirectFunc, typeRead, retry=true, navigate) => {

      // const fnPattern = /(?<=@fn@)(.*?)(?=@efn@)/g;
      // const lnPattern = /(?<=@ln@)(.*?)(?=@eln@)/g;
      // const arlnPattern = /(?<=@arln@)(.*?)(?=@earln@)/g;

      const connectionString = data.connection_string;
      const topicName = data.topic_id;
      const subscriptionName = data.subscription_id;
      // const timeThreshold = data.time_threshold;
      let cptAttpt = -1;

      async function doIt() {
        // create a Service Bus client using the connection string to the Service Bus namespace
        const sbClient = new ServiceBusClient(connectionString);

        // createReceiver() can also be used to create a receiver for a queue.
        const receiver = sbClient.createReceiver(topicName, subscriptionName);

        // function to handle messages
        const myMessageHandler = async (messageReceived) => {
            console.log(messageReceived.body);

            retry = false;
            if (typeRead === TypeReadBus.SCAN_BOARDING_PASS){
              if (messageReceived?.body?.BarcodeData){

                let barcode = messageReceived.body.BarcodeData;
                barcode = atob(barcode);

                barcode = barcode.substring(barcode.indexOf("M1"));

                const fields = parseBCBPBarcode(barcode);

                if (!fields.passengerName || fields.passengerName  === "" || !fields.flightNumber || fields.flightNumber === "" || !fields.fromCity || fields.fromCity === "" || !fields.toCity || fields.toCity === ""){
                  
                  get().actions.rejectPassenger();
                  redirectFunc(-1, SelfBoardingStepEnum.PASSENGER_NOT_FOUND);

                  return;
                }


                let flight_records = [
                    {
                        "id": 999,
                        "pnr": fields.operatingCarrierPNR,
                        "first_name": fields.passengerName.replace(/\//, ' '),
                        "last_name": " ",
                        "flight_number": fields.operatingCarrier+fields.flightNumber,
                        "departure_terminal": "-",
                        "gate": "-",
                        "boarding": "-",
                        "seat": fields.seatNumber,
                        "departure_at": null,
                        "arrival_terminal": "-",
                        "arrival_at": null,
                        "parent_flight_id": null,
                        "passengers_in_group": 1,
                        "departure_airport": {
                            "id": 1,
                            "name": "Singapore Changi",
                            "code": fields.fromCity,
                            "city": airportsDic[fields.fromCity],
                        },
                        "arrival_airport": {
                            "id": 10,
                            "name": "Geneva Airport",
                            "code": fields.toCity,
                            "city": airportsDic[fields.toCity],
                        },
                        "locked": false,
                        "layover": false,
                        "airline": null,
                        "layovers": []
                    }
                ]

                
                get().actions.setFlightRecords([]); 
                get().actions.setFlightRecords(flight_records); 
                get().actions.acceptPassenger();
                redirectFunc(-1, SelfBoardingStepEnum.PASSENGER_BOARDING);
                get().actions.stopLoading();
                
              }
            }
        };

        // function to handle any errors
        const myErrorHandler = async (error) => {
          // console.log(error);
          cptAttpt++;
          if (retry && cptAttpt===0){
            // get().actions.scanPassport(redirectFunc, true);
            get().actions.startTimeout(()=>{
              navigate(AppRoutes.demoChoicesPath);
            }, 30000);
          } 
        };

        // subscribe and specify the message and error handlers
        receiver.subscribe({
            processMessage: myMessageHandler,
            processError: myErrorHandler
        });

        set(produce((state) => { 
            state.messageReceiverBoarding = receiver;
        }));

      }

      // call the main function
      doIt().catch((err) => {
        console.log(err);
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t("ERROR")})
         navigate(AppRoutes.demoChoicesPath);
      });
    }

  }

}))